import computeTagName from "../../../../utils/computeTagName";
import computeClassName from "../../../../utils/computeClassName";
import PartnerSavedTotalCount from "./TotalCount";
import PartnerSavedStatus from "./Status";

const constants = Object.freeze({
  TAG_DEFAULT: 'span',
  CLASSNAME_BASE: 'inline-flex flex-row items-center justify-between text-cc-body-small xs:text-cc-body-medium text-cc-gray-80'
});
const propsDefaults = Object.freeze({
  isSaved: false,
  isActionDisabled: false,
  saveActionTitle: 'Save partner',
  saveActionFn: null,
  saveActionFnArgs: null,
  removeActionTitle: 'Remove partner',
  removeActionFn: null,
  removeActionFnArgs: null,
  isSavingInProgress: false,
  savingInProgressText: 'Partner saving is in progress...',
  tag: constants.TAG_DEFAULT
});

export default function PartnerSaved({
  isSaved = propsDefaults.isSaved,
  isActionDisabled = propsDefaults.isActionDisabled,
  saveActionTitle = propsDefaults.saveActionTitle,
  saveActionFn = propsDefaults.saveActionFn,
  saveActionFnArgs = propsDefaults.saveActionFnArgs,
  removeActionTitle = propsDefaults.removeActionTitle,
  removeActionFn = propsDefaults.removeActionFn,
  removeActionFnArgs = propsDefaults.removeActionFnArgs,
  isSavingInProgress = propsDefaults.isSavingInProgress,
  savingInProgressText = propsDefaults.savingInProgressText,
  savedCount,
  tag = propsDefaults.TAG_DEFAULT,
  className = ''
}) {
  const ComputedTagName = computeTagName(tag, constants.TAG_DEFAULT);
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  return (
    <ComputedTagName className={computedClassName}>
      <PartnerSavedTotalCount savedCount={savedCount} />
      <PartnerSavedStatus isSaved={isSaved}
                          isActionDisabled={isActionDisabled}
                          saveActionTitle={saveActionTitle}
                          saveActionFn={saveActionFn}
                          saveActionFnArgs={saveActionFnArgs}
                          removeActionTitle={removeActionTitle}
                          removeActionFn={removeActionFn}
                          removeActionFnArgs={removeActionFnArgs}
                          isSavingInProgress={isSavingInProgress}
                          savingInProgressText={savingInProgressText}
                          className="ml-1" />
    </ComputedTagName>
  );
}
